<template>
  <form @submit.prevent="sendFile" enctype="multipart/form-data">

    <div v-if="message"
      :class="`message ${error ? 'is-danger' : 'is-success'}`"
    >
      <div class="message-body">{{message}}</div>
    </div>

    <div class="field">
      <div class="file-select" :style="`display: ${uploadedFiles.length>0 ? 'none' : 'flex' }`">
        <label class="file-label">
          <input
            id="fileInput"
            multiple
            type="file"
            ref="files"
            @change="sendFile"
            class="file-input"
          />

          <span class="file-button">
            <span class="file-label">
              Choose file to upload
            </span>
          </span>

        </label>
      </div>

    </div>

    <!-- <div class="field">
      <div v-for="(file, index) in files" :key="index" class="file-item" :class="`file-item ${file.invalidMessage && 'has-text-danger'}`">
        <div class="level-top row">
          <div class="level-left col-lg-6">
            <div class="global-h-gutter"><svg width="48" height="48" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="24" cy="24" r="24" fill="#F0F4F0"></circle> <path d="M17 16h14v17H17V16z" fill="#fff" stroke="#91C855" stroke-width="2"></path> <path d="M20.5 24.5h7M20.5 21.5h7M20.5 27.5h7" stroke="#91C855" stroke-linecap="round" stroke-linejoin="round"></path></svg></div>
            <div class="level-item m-l-20">{{file.name}}</div>
            <span v-if="file.invalidMessage">&nbsp;- {{file.invalidMessage}}</span>
          </div>

          <div class="level-right col-lg-6">
            <div class="level-item">
              <a @click.prevent="files.splice(index, 1);uploadFiles.splice(index, 1)" class="delete"></a>
            </div>
          </div>
        </div>

        <div class="level-bot">
          <select class="file-type">
            <option v-for="(option, index) in options" :key="index">
              {{ option.text }}
            </option>
          </select>
        </div>
      </div>
    </div> -->

    <div class="field">
      <div v-for="(file, index) in uploadedFiles" :key="index" class="file-item">
        <div class="level-top row">
          <div class="level-left col-lg-12">
            <div class="global-h-gutter"><svg width="48" height="48" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="24" cy="24" r="24" fill="#F0F4F0"></circle> <path d="M17 16h14v17H17V16z" fill="#fff" stroke="#91C855" stroke-width="2"></path> <path d="M20.5 24.5h7M20.5 21.5h7M20.5 27.5h7" stroke="#91C855" stroke-linecap="round" stroke-linejoin="round"></path></svg></div>
            <div class="level-item m-l-20">{{file.name}}</div>
            <div class="level-item delete-button">
              <a @click.prevent="uploadedFiles.splice(index, 1)" class="delete"></a>
            </div>
          </div>

          <!-- <div class="level-right col-lg-6">
            <div class="level-item">
              <a @click.prevent="uploadedFiles.splice(index, 1)" class="delete"></a>
            </div>
          </div> -->
        </div>

        <div class="level-bot">
          <select class="file-type" @change="onChange(file, $event)">
            <option disabled selected>
              What type of document is this?
            </option>
            <option v-for="(option, index) in options" :key="index">
              {{ option.text }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <div :style="`display: ${uploadedFiles.length==0 ? 'none' : 'block'}`">
      <hr>
      <button class="button hollow add-owner" @click="$refs.files.click()"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.66602 2.66699H7.33268V7.33366H2.66602V8.66699H7.33268V13.3337H8.66602V8.66699H13.3327V7.33366H8.66602V2.66699Z" fill="#053A7A"></path></svg>
        Add Document
      </button>
    </div>

    <!-- <div class="field">
      <button class="button is-info">Send</button>
    </div> -->

  </form>
</template>

<script>
import form from '../../vuex/modules/form';
import _ from 'lodash';
import axios from 'axios';

export default {
  name: "MultipleUploads",
  data() {
    return {
      files: [],
      uploadFiles: [],
      uploadedFiles: [],
      message: "",
      error: false,
      selected: 'What type of document is this?',
      options: [
        // { text: 'What type of document is this?', value: 'What type of document is this?' },
        { text: 'Current rent roll', value: 'current_rent_roll' },
        { text: 'Property operating statements', value: 'property_operating_statements' },
        { text: 'Purchase contract', value: 'purchase_contract' },
        { text: 'Tax returns', value: 'tax_returns' },
        { text: 'Current lease', value: 'current_lease' },
        { text: 'FNMA 1003 form', value: 'FNMA_1003_form' },
        { text: 'Letter of Explanation', value: 'letter_of_explanation' },
        { text: 'Application', value: 'application' },
        { text: 'Balance Sheet', value: 'balance_sheet' },
        { text: 'Banks', value: 'banks' },
        { text: 'Bill of Sale', value: 'bill_sale' },
        { text: 'Broker Credit', value: 'broker_credit' },
        { text: 'Business Taxes', value: 'business_taxes' },
        { text: 'Comp', value: 'comp' },
        { text: 'Credit.Net', value: 'credit_net' },
        { text: 'Cross Corp', value: 'cross_corp' },
        { text: 'Cross Corp Taxes', value: 'cross_corp_taxes' },
        { text: 'Customer CLEAR', value: 'customer_clear' },
        { text: 'D&B', value: 'd_b' },
        { text: 'Experian', value: 'experian' },
        { text: 'Financials', value: 'financials' },
        { text: 'Foreign SOS', value: 'foreign_sos' },
        { text: 'Home Ownership', value: 'home_ownership' },
        { text: 'Inactive SOS', value: 'inactive_sos' },
        { text: 'Inactive Safer', value: 'inactive_safer' },
        { text: 'Individual Taxes', value: 'individual_taxes' },
        { text: 'Invoice', value: 'invoice' },
        { text: 'Misc Docs From Broker', value: 'misc_docs_broker' },
        { text: 'PG CLEAR', value: 'pg_clear' },
        { text: 'PPP - Additional Doc', value: 'ppp_additional_doc' },
        { text: 'PPP - Government ID Back', value: 'ppp_government_id_back' },
        { text: 'PPP - Government ID Front', value: 'ppp_government_id_front' },
        { text: 'PPP - Organizational Official Documents', value: 'ppp_organizational_official_documents' },
        { text: 'PPP - Payroll', value: 'ppp_payroll' },
        { text: 'PPP - Proof of Record Business', value: 'ppp_proof_of_record_business' },
        { text: 'PPP - Proof of Record Employees', value: 'ppp_proof_of_record_employees' },
        { text: 'PPP – Signature', value: 'ppp_signature' },
        { text: 'Paynet', value: 'paynet' },
        { text: 'Personal Financial Statement', value: 'personal_financial_statement' },
        { text: 'Potential Cross Corp', value: 'potential_cross_corp' },
        { text: 'Profit & Loss', value: 'profit_loss' },
        { text: 'Quote / Estimate', value: 'quote_estimate' },
        { text: 'R&D - Bank Statements', value: 'df_bank_statement' },
        { text: 'R&D - Financial or Tax Statements', value: 'df_financial_tax' },
        { text: 'R&D - SBA Proof of Funds Received', value: 'df_sba' },
        { text: 'R&D - YTD Business Financials', value: 'df_ytd' },
        { text: 'Safer', value: 'safer' },
        { text: 'Secretary of State', value: 'secretary_state' },
        { text: 'Specs', value: 'specs' },
        { text: 'Startup Questionaire', value: 'startup_questionaire' },
        { text: 'Submission Email', value: 'submission_email' },
        { text: 'Time in Business', value: 'time_business' },
        { text: 'Website', value: 'website' }
      ]
    }
  },

  methods: {
    // selectFile() {
    //   const files = this.$refs.files.files;
    //   this.uploadFiles = [...this.uploadFiles, ...files ];

    //   this.files = [
    //     ...this.files,
    //     ..._.map(files, file => ({
    //       name: file.name,
    //       size: file.size,
    //       type: file.type,
    //       invalidMessage: this.validate(file)
    //     }))
    //   ]
    // },

    onChange(file, e) {
      const val = e.target.value;
      file.category = e.target.options[e.target.options.selectedIndex].text;
      console.log(this.uploadedFiles);
    },

    validate(file) {
      const MAX_SIZE = 25 * 1024 * 1024;

      //TODO: add word to allowed upload file
      const allowedTypes = ["image/jpeg", "image/png", "image/gif", "application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/pdf", "application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"];

      if(file.size > MAX_SIZE) {
        return `Max size: 25MB`;
      }

      if(!allowedTypes.includes(file.type)) {
        return "Not allowed file type";
      }

      return "";
    },

    async sendFile() {
      console.log('test' + this.$refs.files.files);
      const files = this.$refs.files.files;
      console.log('test' + files);
      if(files==null || files.length==0) return;
      this.uploadFiles = [...this.uploadFiles, ...files ];

      this.files = [
        ...this.files,
        ..._.map(files, file => ({
          name: file.name,
          size: file.size,
          type: file.type,
          invalidMessage: this.validate(file)
        }))
      ]

      const formData = new FormData();
      _.forEach(this.uploadFiles, file => {
        if(this.validate(file) === "") {
          formData.append('files', file);
        }
      });

      try{
        const result = await axios.post("https://api.amcredit.com/apply/upload", formData);
        console.log(result);
        this.uploadedFiles = [...this.uploadedFiles, ...result.data.urls ];
        
        // event to send files to parent
        this.$emit('ready', this.uploadedFiles);

        this.message = "Files have been uploaded";
        this.files = [];
        this.uploadFiles = [];
        this.error = false;
        this.$refs.files.value = '';
      } catch (err) {
        this.message = err.response.data.errorr;
        this.error = true;
      }
    }
  }
}
</script>

<style lang="scss">
  .message {
    background-color: #f5f5f5;
    border-radius: 4px;
    font-size: 1rem;
    &.is-success {
      background-color: #f6fef9;
      .message-body {
        border-color: #23d160;
        color: #0e301a;
      }
    }
    .message-body {
      border-color: #dbdbdb;
      border-radius: 4px;
      border-style: solid;
      border-width: 0 0 0 4px;
      color: #4a4a4a;
      padding: 1.25em 1.5em;
    }
  }

  .message:not(:last-child) {
    margin-bottom: 1.5rem;
  }


  .add-owner {
    border: 1px solid #91c855;
    color: #053A7A;
    font-size: .75rem;
    line-height: 1rem;
    padding: 0.6875rem 1.5rem;
    border-radius: 1.25rem;
    letter-spacing: 1px;
    text-align: center;
    font-weight: 600;
    text-transform: uppercase;
    min-width: 9.75rem;
    height: 40px;
    font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
  }
  .add-owner:hover {
    border-color: #496c23;
    color: #496c23;
  }
  .field {
    margin-top: 1.875rem;
    .file-select {
      font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
      font-weight: 400;
      line-height: 1.5;
      color: #053A7A;
      -webkit-font-smoothing: antialiased;
      box-sizing: inherit;
      margin: 0;
      padding: 0;
      cursor: pointer;
      border-radius: .5rem;
      margin-bottom: 1.875rem;
      margin-top: 1.875rem;
      border: 1px solid #c1c4c2;
      display: flex;
      justify-content: center;
      align-content: center;
      width: 100%;
      .file-label {
        display: inline-block;
        .file-input {
          height: 0.01em;
          left: 0;
          outline: 0;
          position: absolute;
          top: 0;
          width: 0.01em;
        }
      }
    }
    .file-item {
      border: 1px solid #c1c4c2;
      padding: 2.8125rem 2rem;
      margin-bottom: 1.875rem;
      border-radius: 0.5rem;
      font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
      font-weight: 400;
      line-height: 1.5;
      color: #053A7A;
      -webkit-font-smoothing: antialiased;
      .level-top {
        margin-bottom: 1.875rem;
        .m-l-20 {
          margin-left: 20px;
        }
        .level-left {
          align-items: center;
          justify-content: flex-start;
        }
        .level-right {
          align-items: center;
          justify-content: flex-end;
        }
        .delete-button {
          display: flex;
          margin-left: auto;
        }
        .level-item {
          align-items: center;
          display: flex;
          flex-basis: auto;
          flex-grow: 0;
          flex-shrink: 0;
          justify-content: center;
          .delete {
            -moz-appearance: none;
            -webkit-appearance: none;
            background-color: rgba(10,10,10,.2);
            border: none;
            border-radius: 290486px;
            cursor: pointer;
            display: inline-block;
            flex-grow: 0;
            flex-shrink: 0;
            font-size: 0;
            height: 20px;
            max-height: 20px;
            max-width: 20px;
            min-height: 20px;
            min-width: 20px;
            outline: 0;
            position: relative;
            vertical-align: top;
            width: 20px;
          }
          .delete::before {
            height: 2px;
            width: 50%;
            background-color: #fff;
            content: "";
            display: block;
            left: 50%;
            position: absolute;
            top: 50%;
            -webkit-transform: translateX(-50%) translateY(-50%) rotate(45deg);
            transform: translateX(-50%) translateY(-50%) rotate(45deg);
            -webkit-transform-origin: center center;
            transform-origin: center center;
          }
          .delete::after {
            height: 50%;
            width: 2px;
            background-color: #fff;
            content: "";
            display: block;
            left: 50%;
            position: absolute;
            top: 50%;
            -webkit-transform: translateX(-50%) translateY(-50%) rotate(45deg);
            transform: translateX(-50%) translateY(-50%) rotate(45deg);
            -webkit-transform-origin: center center;
            transform-origin: center center;
          }
        }
      }
      .level-bot {
        .file-type {
          text-transform: none;
          box-sizing: border-box;
          width: 100%;
          height: 3.4375rem;
          margin: 0 0 1rem;
          appearance: none;
          border: 0;
          border-radius: .25rem;
          background-color: #f0f4f0;
          font-family: inherit;
          font-size: 1rem;
          font-weight: 600;
          line-height: 1.5;
          color: #053A7A;
          background-repeat: no-repeat;
          transition: box-shadow .5s,border-color .25s ease-in-out,padding-top .25s ease-in-out;
          padding: 1rem 1.5rem 1rem 1rem;
          background-image: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg opacity='0.5'%3E%3Cpath d='M4 6L8 10L12 6' stroke='%23053A7A'/%3E%3C/g%3E%3C/svg%3E%0A");
          margin-bottom: .5rem;
          background-size: 16px 16px;
          background-position: right 1.25rem center;
          background-origin: border-box;
          padding-top: 0;
          padding-bottom: 0;
        }
      }
    }

    .file-item:last-child {
      margin-bottom: 0.275rem;
    }
  }
  
  .file-button{
    font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
    font-weight: 400;
    line-height: 1.5;
    color: #053A7A;
    -webkit-font-smoothing: antialiased;
    box-sizing: inherit;
    margin: 0;
    padding: 0;
    cursor: pointer;
    border-radius: .5rem;
    border: none;
    background-color: transparent;
    display: flex;
    justify-content: center;
    align-content: center;

    .file-label {
      box-sizing: inherit;
      word-break: break-word;
      display: inline-block;
      vertical-align: middle;
      transition: background-color .25s ease-out,color .25s ease-out;
      font-family: inherit;
      -webkit-appearance: none;
      font-size: .75rem;
      line-height: 1rem;
      padding: .6875rem 1.5rem;
      border-radius: 1.25rem;
      letter-spacing: 1px;
      text-align: center;
      text-transform: uppercase;
      font-weight: 400;
      outline: 0;
      background-color: transparent;
      border: 1px solid #91c855;
      min-width: 0;
      cursor: pointer;
      color: #053A7A;
      margin: 2.8125rem;
    }
    .file-label:hover {
      border-color: #496c23;
      color: #496c23;
    }
  }

  @media screen and (min-width: 769px), print {
    .level-left, .level-right {
      display: flex;
    }
  }

  @media screen and (max-width: 768px) {
  .file-item {
    .level-top {
      .level-left {
        display: flex;
        align-items: flex-start;
        .global-h-gutter {
          align-items: flex-start;
        }
      }
      .level-right {
        display: none;
      }
      .delete-button {
        display: flex;
        margin-left: auto;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// MultipleUploads.vue?260b31ac